<template>
    <div class="container">
        <div class="row">
            <div class="col-md-8 offset-md-2">
                <div class="text-center mt-4 mb-4">
                    <h1 class="display-4">Política de Privacidade</h1>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <h5 class="card-title">Condições Gerais</h5>
                        <p>
                            Ao baixar ou usar o app, estes termos serão aplicados automaticamente a você — portanto,
                            leia-os com atenção antes de usar o app.
                        </p>
                        <p>
                            Você não tem permissão para copiar ou modificar o app, qualquer parte do app, ou
                            nossas marcas de nenhuma maneira.
                        </p>
                        <p>
                            Você não tem permissão para tentar extrair o código-fonte do app, nem deve tentar
                            traduzir o app para outros idiomas ou criar versões derivadas.
                        </p>
                        <p>
                            O app e todas as marcas, direitos autorais, direitos de base de dados e outros direitos
                            de propriedade intelectual relacionados a ele continuam pertencendo a Florian Zopf.
                        </p>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <h5 class="card-title">Alterações no Serviço e Cobranças</h5>
                        <p>
                            Florian Zopf está comprometido em garantir que o app seja o mais útil e eficiente possível.
                        </p>
                        <p>
                            Reservamo-nos o direito de fazer alterações no app ou cobrar por seus serviços,
                            a qualquer momento e por qualquer motivo.
                        </p>
                        <p>
                            Nunca cobraremos pelo app ou por seus serviços sem deixar muito claro exatamente
                            pelo que você está pagando.
                        </p>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <h5 class="card-title">Segurança de Dados e Privacidade</h5>
                        <p>
                            O app Qwik VBT armazena e processa dados pessoais que você nos forneceu para que possamos
                            prestar o Serviço.
                        </p>
                        <p>
                            Para oferecer o modo online, armazenamos dados do usuário na nuvem. Levamos muito a sério
                            a privacidade e a segurança dos seus dados e implementamos medidas padrão do setor para
                            protegê-los contra acesso, divulgação, alteração e destruição não autorizados.
                        </p>
                        <p>
                            No entanto, nenhum método de armazenamento eletrônico ou de transmissão pela Internet é 100% seguro,
                            e não podemos garantir a segurança absoluta dos seus dados.
                        </p>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <h5 class="card-title">Serviços de Terceiros</h5>
                        <p>
                            O app utiliza serviços de terceiros que declaram seus Termos e Condições.
                        </p>
                        <p>
                            Link para os Termos e Condições dos provedores de serviços de terceiros utilizados pelo app:
                        </p>
                        <ul>
                            <li><a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer">Google
                                    Play
                                    Services</a></li>
                        </ul>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <h5 class="card-title">Login com Google</h5>
                        <p>
                            Em nosso app, oferecemos a opção de entrar com o Google para sua conveniência. Esse processo
                            exige acesso ao seu endereço de e-mail, que usamos apenas como um identificador exclusivo dentro
                            do app. Respeitamos sua privacidade: seu e-mail nunca é compartilhado, vendido ou usado para
                            qualquer outro propósito. Ao escolher entrar com o Google, você consente com esse uso limitado
                            do seu e-mail.
                        </p>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <h5 class="card-title">Responsabilidade e Uso</h5>
                        <p>
                            Florian Zopf não pode se responsabilizar caso o app não funcione com plena funcionalidade
                            se você não tiver acesso a Wi‑Fi e não tiver franquia de dados disponível.
                        </p>
                        <p>
                            Da mesma forma, Florian Zopf nem sempre pode se responsabilizar pela forma como você usa o app; por exemplo,
                            você precisa garantir que seu dispositivo permaneça carregado.
                        </p>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <h5 class="card-title">Atualizações e Encerramento</h5>
                        <p>
                            Em algum momento, poderemos desejar atualizar o app. Florian Zopf não promete que ele será sempre atualizado
                            para que seja relevante para você e/ou funcione com a versão do Android e iOS instalada em seu dispositivo.
                        </p>
                        <p>
                            No entanto, você se compromete a aceitar sempre as atualizações do aplicativo quando oferecidas.
                            Também podemos deixar de fornecer o app e encerrar seu uso a qualquer momento, sem aviso.
                        </p>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <h5 class="card-title">Instruções e Funcionamento Ideal</h5>
                        <p>
                            É fundamental que os usuários sigam as instruções fornecidas no app para garantir seu funcionamento ideal.
                        </p>
                        <p>
                            Não seguir as instruções pode resultar em resultados imprecisos e o app pode não funcionar conforme o esperado.
                            Florian Zopf não pode ser responsabilizado por quaisquer problemas ou imprecisões decorrentes do não cumprimento
                            das instruções do app.
                        </p>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <h5 class="card-title">Alterações aos Termos e Condições</h5>
                        <p>
                            Podemos atualizar nossos termos e condições periodicamente para refletir mudanças em nosso app e serviços.
                        </p>
                        <p>
                            O uso contínuo do app constitui aceitação dos novos termos e condições. Recomendamos que você revise
                            periodicamente os termos e condições em busca de atualizações.
                        </p>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <h5 class="card-title">Fale Conosco</h5>
                        <p>
                            Se você tiver quaisquer dúvidas ou sugestões sobre os Termos e Condições, não hesite em entrar em
                            contato pelo e-mail qwikvbt@gmail.com.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div></template>


